import { Component } from 'react'
import { Sortings } from 'stylewhere/api'
import { OperationStart } from 'stylewhere/components'
import { SortingExtensions } from 'stylewhere/extensions'
import { FormSchema, RemoteOperation, Router, SortingOperationConfig, useMatchParams } from 'stylewhere/shared'
import { isModalError, showToastError } from 'stylewhere/utils'
import { T, __ } from 'stylewhere/i18n'

interface SortingStartProps {
  match: { params: { opCode: string; code?: string } }
  location: any
  history: any
}

class SortingStart extends Component<SortingStartProps> {
  get opCode() {
    return this.props.match.params.opCode
  }
  
  get code() {
    return this.props.match.params.code
  }
  
  operation = RemoteOperation.getOperationConfig<SortingOperationConfig>(this.opCode)
  submitPath = '/sorting/:opCode/reading' as any
  isModal = false

  componentDidMount() {
    if (!this.operation.showCreateButton) {
      Router.navigate(`/sorting/:opCode`, { opCode: this.operation.code })
    }
    this.isModal = isModalError(this.operation)
  }

  onSubmitForm = async (formData: any, operation: SortingOperationConfig, schema: FormSchema) => {
    if (formData.pickingIds) {
      try {
        const res = await Sortings.createFromPicking<any>(
          formData.pickingIds.map((p) => p.id),
          operation.id,
          formData
        )
        Router.navigate(
          this.submitPath,
          { opCode: operation.code },
          { state: { formData: { ...formData, sortingId: res.id } } }
        )
      } catch (error) {
        showToastError(error, __(T.error.error), this.isModal)
      }
    } else {
      Router.navigate(this.submitPath, { opCode: operation.code }, { state: { formData } })
    }
  }

  render() {
    return (
      <OperationStart
        backPath="/sorting/:opCode"
        submitPath={this.submitPath}
        onSubmit={this.onSubmitForm}
        extensions={SortingExtensions}
      />
    )
  }
}

export default SortingStart
